import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-351fc0d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "d-flex justify-space-between align-center" }
const _hoisted_3 = { class: "d-flex align-center" }
const _hoisted_4 = { class: "d-flex justify-space-between align-end" }
const _hoisted_5 = {
  key: 1,
  class: "value"
}

import { withDefaults, watch, defineAsyncComponent, ref } from 'vue';
import { AtomInfoCard, AtomToogleButton, AtomSubTitle, MoreHorizontalIcon, LoaderIcon } from '@/components/atoms';
import * as comps from '@/components/atoms';
import { formatLang, formatNumber } from '@/utils/formatNumber'

import { IItemDiagnostic } from '@/types';
import AtomButton from '../atoms/AtomButton.vue';
interface IProps {
  itemDiagnostic: IItemDiagnostic
  loading?: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeDiagnostic',
  props: {
    itemDiagnostic: {},
    loading: { type: Boolean }
  },
  emits: ['handleToggle', 'clickMore'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

function handleCLickMore() {
  emit('clickMore')
}

return (_ctx: any,_cache: any) => {
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "area-icon me-2 pa-1",
          style: _normalizeStyle({ backgroundColor: props.itemDiagnostic.color })
        }, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(comps[props.itemDiagnostic.icon]), {
            color: props.itemDiagnostic.iconColor
          }, null, 8, ["color"]))
        ], 4),
        _createVNode(_unref(AtomSubTitle), {
          "no-margin": "",
          text: props.itemDiagnostic.item,
          class: "title-card"
        }, null, 8, ["text"])
      ]),
      _createVNode(AtomButton, {
        id: 'menu-activator-' + props.itemDiagnostic.id,
        background: "transparent",
        class: "pa-0"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(MoreHorizontalIcon))
        ]),
        _: 1
      }, 8, ["id"]),
      _createVNode(_component_v_menu, {
        activator: '#menu-activator-' + props.itemDiagnostic.id
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_list, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item, { value: "printer" }, {
                default: _withCtx(() => [
                  _createVNode(AtomButton, {
                    background: "white",
                    text: "Investigar",
                    onClick: handleCLickMore
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["activator"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (props.loading)
        ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(LoaderIcon)), {
            key: 0,
            class: "ma-auto"
          }))
        : (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(props.itemDiagnostic.value), 1)),
      (!props.loading && props.itemDiagnostic.nFloat)
        ? (_openBlock(), _createBlock(comps.AtomBadge, {
            key: 2,
            color: "#000000",
            bgColor: "#DCDCDC",
            text: props.itemDiagnostic.nFloat,
            class: "percent"
          }, {
            icon: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(props.itemDiagnostic.isPositive ? comps.ArrowUpIcon : comps.ArrowDownIcon), { color: "#868E96" }))
            ]),
            _: 1
          }, 8, ["text"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})